import { useEffect } from "react";
import { useDispatch } from "react-redux";
import actionTypes from "../action/actionTypes";
import getAnswersFromParams from "../functions/getAnswersFromParams";


export const useResultsRequest  = (searchParams) => {
    const dispatch = useDispatch()

    useEffect(() => {
        const items = getAnswersFromParams(searchParams)

        dispatch({
            type: actionTypes.MATRIX_RESULTS_REQUEST,
            payload: {
                userAnswers: items,
            },
        });
    }, []);
}